import React, { useState } from "react";
import Button from "../ui/Button";
import OtpInput from "react-otp-input";
import logo from "../../assets/logo-2.png";
import { useDispatch, useSelector } from "react-redux";
import { verifyOtp } from "../../store/slice/auth";

const OtpDialog = ({
  children,
  variant = "primary",
  size = "sm",
  fullWidth = false,
  buttonShow = [],
  className,
  onCancel,
  isOTPDialogOpen,
  actionButtonName,
  formData,
  afterValidate,
  closeDialog,
  isUpdateNumber,
  handleResend,
  ...props
}) => {
  const dispatch = useDispatch();
  const { otpToken } = useSelector((state) => state.auth);
  const [otp, setOtp] = useState("");
  const [otpErr, setOtpErr] = useState("");

  // This function will now directly receive the OTP value
  const onValidateOtp = () => {
    if (!otp || otp.length < 4) {
      setOtpErr("Please enter a valid OTP");
      return;
    }
    if (isUpdateNumber) {
      const data = {
        otpToken: otpToken,
        forgotPassword: null,
        phoneNumber: formData?.contactNo,
        verificationCode: otp,
        countryCode: formData?.countryCode,
      };

      dispatch(verifyOtp(data, afterValidate, closeDialog));
    } else {
      const data = {
        email: formData?.email || "",
        otpToken: otpToken,
        forgotPassword: null,
        phoneNumber: formData?.phoneNumber || "",
        verificationCode: otp,
        countryCode: formData?.phoneNumber ? formData?.countryCode : "",
      };

      dispatch(verifyOtp(data, afterValidate, closeDialog));
    }
  };

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
        onClick={closeDialog}
      >
        <div onClick={(e) => e.stopPropagation()}>
          <div className="w-full max-w-md bg-white shadow-xl rounded-xl p-8 relative">
            {/* Top Gradient Line */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#2BACE2] via-[#057BB5] to-[#2BACE2] rounded-t-xl"></div>

            {/* Logo */}
            <div className="flex justify-center mb-5">
              <img src={logo} alt="Logo" className="w-40" />
            </div>

            <h2 className="text-2xl font-semibold text-center text-gray-800">
              OTP Verification
            </h2>

            <p className="text-sm text-gray-500 text-center mt-2 mb-6 px-4">
              Please enter the 4 digit code sent to{" "}
              <span className="text-highlight font-semibold">
                {" "}
                {isUpdateNumber
                  ? formData?.countryCode + formData?.contactNo
                  : formData?.email}
              </span>
            </p>
            <div className="flex justify-center mb-7">
              <div>
                <OtpInput
                  value={otp}
                  onChange={(e) => {
                    setOtp(e);
                    if (e?.length >= 4) {
                      setOtpErr("");
                    }
                  }}
                  numInputs={4}
                  renderSeparator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                  inputStyle={{
                    width: "45px",
                    height: "45px",
                    margin: "0 5px",
                    fontSize: "20px",
                    borderRadius: "8px",
                    border: "2px solid #ccc",
                    textAlign: "center",
                  }}
                />
                <p className="text-sm text-gray-500 text-center mt-2 px-4">
                  Didn't Receive Code? &nbsp;
                  <span
                    onClick={handleResend}
                    className="text-highlight cursor-pointer font-semibold"
                  >
                    Resend
                  </span>
                </p>
              </div>
            </div>
            {otpErr && (
              <div className="text-red-400 font-semibold text-sm text-center">
                {otpErr}
              </div>
            )}
            <div className="flex  gap-2 mt-4">
              <Button
                variant="secondary"
                children={"Cancel"}
                fullWidth
                onClick={closeDialog}
              />
              <Button
                style={{ marginLeft: "auto" }}
                children={"Done"}
                fullWidth
                onClick={onValidateOtp}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtpDialog;
